import React from 'react';

type MailIconProps = {
  className?: string;
  color?: string;
};

const MailIcon: React.FC<MailIconProps> = ({ className, color = '#003366' }) => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M14.168 17.0832H5.83464C3.33464 17.0832 1.66797 15.8332 1.66797 12.9165V7.08317C1.66797 4.1665 3.33464 2.9165 5.83464 2.9165H14.168C16.668 2.9165 18.3346 4.1665 18.3346 7.08317V12.9165C18.3346 15.8332 16.668 17.0832 14.168 17.0832Z" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.1654 7.5L11.557 9.58333C10.6987 10.2667 9.29036 10.2667 8.43203 9.58333L5.83203 7.5" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

export default MailIcon;